module.exports = __webpack_public_path__ + "799700c90006971203c0593eadcdf98d.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/slack-info/slack-info.html
// module id = 1868
// module chunks = 0